module.exports = __webpack_public_path__ + "img/13_29.31356951.png";